import React, { useState, useEffect } from "react";
import { DebounceInput } from "react-debounce-input";

export default function JobFilterForm({ searchParams, setParams }) {
  const [worktypeArray, setWorktypeArray] = useState([]);
  const [jobtypeArray, setJobtypeArray] = useState([]);

  const [keyword, setKeyword] = useState("");
  const [typeOfWork, setTypeOfWork] = useState([]);
  const [location, setLocation] = useState("");
  const [jobType, setJobType] = useState([]);
  const [postDate, setPostDate] = useState([]);

  const postDateList = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 14 Days",
    "Last 30 Days",
    "All",
  ];
  const [postDateArray, setPostDateArray] = useState(postDateList);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    axios.get(constvar.api_url + "home/job_filter_data", { signal: controller.signal }).then((response) => {
      if (!isMounted) return; //Guard skip state if unmounted
      if (response.data.status == "success") {
        setWorktypeArray(response.data.worktype);
        setJobtypeArray(response.data.jobtype);
      } else {
        setWorktypeArray([]);
        setJobtypeArray([]);
      }
    }).catch(error => {
      if (!isMounted) return;
      if (error.name !== "AbortError"  && error.name !== "CanceledError") {
        console.error("Failed to load job filter data:", error);
      }
    });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  useEffect(() => {
    var data = {
      keyword: keyword,
      typeOfWork: typeOfWork,
      location: location,
      jobType: jobType,
      postDate: postDate,
    };

    setParams(data);
  }, [keyword, typeOfWork, location, jobType, postDate]);

  const addWorkTypeOptions = (e) => {
    var id = e.currentTarget.value;
    var workType = typeOfWork;
    if (workType.includes(id)) {
      workType.splice(workType.indexOf(id), 1);
      setTypeOfWork([...workType]);
      return;
    }
    workType.push(id);
    setTypeOfWork([...workType]);
  };

  const addJobTypeOptions = (e) => {
    var id = e.currentTarget.value;
    var jobTypeArr = jobType;
    if (jobTypeArr.includes(id)) {
      jobTypeArr.splice(jobTypeArr.indexOf(id), 1);
      setJobType([...jobTypeArr]);
      return;
    }
    jobTypeArr.push(id);
    setJobType([...jobTypeArr]);
  };

  return (
    <form>
      <div className="widget tw-sidebar-tags-wrap">
        <h4 className="section-head-small mb-3">
          <i class="ri-list-check"></i> Filter
        </h4>

        {/* <div className="tagcloud"> 
          <a href="#">Jobs</a>
          <a href="#">Freelance </a>
          <a href="#">Entrepreneurship</a>
        </div> */}
      </div>

      <div className="form-group mb-4">
        <h4 className="section-head-small mb-3">
          <i class="ri-search-line"></i> Search By Keyword
        </h4>
        <div className="input-group">
          <DebounceInput
            minLength={2}
            debounceTimeout={300}
            className="form-control"
            placeholder="Job Title, Skill or Organization"
            name="keyword"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
          <button className="btn" type="button">
            <i className="ri-search-line"></i>
          </button>
        </div>
      </div>

      <div className="twm-sidebar-ele-filter">
        <h4 className="section-head-small mb-3">
          <i class="ri-briefcase-line"></i> Type of Work
        </h4>
        <ul>
          {worktypeArray.length > 0
            ? worktypeArray.map((wtype, ind) => (
                <li key={`work-type${ind}`}>
                  <div className=" form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`workType${ind}`}
                      value={wtype.id}
                      name="typeOfWork[]"
                      onClick={addWorkTypeOptions}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`workType${ind}`}
                    >
                      {wtype.title}
                    </label>
                  </div>
                </li>
              ))
            : ""}
        </ul>
      </div>

      <div className="form-group mb-4 serach_by_location">
        <h4 className="section-head-small mb-3">
          <i class="ri-map-pin-line"></i> Location
        </h4>
        <div className="input-group">
          <DebounceInput
            minLength={2}
            debounceTimeout={300}
            className="form-control"
            placeholder="Search location"
            name="location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
          <button className="btn" type="button">
            <i className="ri-map-pin-line"></i>
          </button>
        </div>
      </div>

      <div className="twm-sidebar-ele-filter">
        <h4 className="section-head-small mb-3">
          <i class="ri-briefcase-line"></i> Job Type
        </h4>
        <ul>
          {jobtypeArray.length > 0
            ? jobtypeArray.map((jtype, idx) => (
                <li key={`job-type${idx}`}>
                  <div className=" form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`jobTypeCheck${idx}`}
                      value={jtype.id}
                      onClick={addJobTypeOptions}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`jobTypeCheck${idx}`}
                    >
                      {jtype.title}
                    </label>
                  </div>
                  <span className="twm-job-type-count">
                    {jtype.job_type_count}
                  </span>
                </li>
              ))
            : ""}
        </ul>
      </div>

      <div className="twm-sidebar-ele-filter">
        <h4 className="section-head-small mb-3">
          <i class="ri-calendar-line"></i> Date Posts
        </h4>
        <ul>
          {postDateArray.length > 0
            ? postDateArray.map((title, ind) => (
                <li key={`post-data${ind}`}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="postdate"
                      id={title}
                      value={title}
                      onClick={(e) => {
                        setPostDate(e.currentTarget.value);
                      }}
                    />
                    <label className="form-check-label" for={title}>
                      {title}
                    </label>
                  </div>
                </li>
              ))
            : null}
        </ul>
      </div>
    </form>
  );
}
